import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';

class CommissionSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: this.props.data,
      search: '',
    };
  }

  onChange = (event, { newValue }) => {
    if (!newValue) {
      this.props.handleClick({});
    }
    this.setState({
      search: newValue,
    });
  };

  getSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? this.props.data
      : this.props.data.filter(
          (data) =>
            data.name.toLowerCase().slice(0, inputLength) === inputValue ||
            (data.address && data.address.toLowerCase().slice(0, inputLength) === inputValue) ||
            (data.city && data.city.toLowerCase().slice(0, inputLength) === inputValue)
        );
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: this.props.data,
    });
  };

  renderSuggestion(suggestion) {
    var address = '';
    if (suggestion.address) address += suggestion.address + ', ';
    if (suggestion.city) address += suggestion.city + ', ';
    if (suggestion.state) address += suggestion.state;

    return (
      <div
        className='org-name'
        onClick={() => {
          this.props.handleClick(suggestion);
        }}
      >
        {suggestion.name + ' : ' + address}
      </div>
    );
  }
  renderSuggestionsContainer({ children, ...rest }) {
    return (
      <div {...rest} style={{}}>
        {children}
      </div>
    );
  }

  render() {
    let value = this.state.search;
    const inputProps = {
      placeholder: 'Search by name, address, or city',
      value,
      onChange: this.onChange,
    };
    let title =
      this.props.org && this.props.org.name
        ? 'Selected Org: ' + this.props.org.name
        : 'Select an Org';
    return (
      <div className='container'>
        <div className='content pure-g'>
          <h2 className='pure-u-1' style={{ marginTop: 20 }}>
            {title}
          </h2>
          <div className='pure-form pure-form-horizontal pure-g pure-u-1'>
            <div className='pure-u-1'>
              <Autosuggest
                suggestions={this.state.suggestions}
                alwaysRenderSuggestions={true}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                getSuggestionValue={(suggestion) => suggestion.name}
                renderSuggestion={this.renderSuggestion.bind(this)}
                renderSuggestionsContainer={this.renderSuggestionsContainer.bind(this)}
                inputProps={inputProps}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CommissionSearch;



// WEBPACK FOOTER //
// ./src/components/CommissionSearch.js